export default __webpack_public_path__ + "static/media/granada.cac351fe.png";